import { IExercise, ISession } from "@hulanbv/platformapp";
import { CrudService, IHttpOptions, IResponse } from "nest-utilities-client";
import { environment } from "../../constants/environment.constants";
import { httpService } from "../common/http.service";

class Service extends CrudService<ISession> {
  constructor() {
    super([environment.apiUrl, "sessions"].join("/"), httpService);
  }

  getAllRequest = this.getAll;

  getRequest = this.get;

  get = async (
    id: string,
    options?: Omit<IHttpOptions, "body" | "method" | "url">,
  ): Promise<IResponse<ISession>> => {
    const response = await this.getRequest(id, options);

    // manually sort the populated exercises based on the order of the exerciseIds in the session
    if (response.data.exercises) {
      const sortedExercises: IExercise[] = [];
      response.data.exercises.forEach((exercise) => {
        const index = response.data.exerciseIds?.indexOf(exercise._id);
        if (index !== undefined && index !== -1) {
          sortedExercises[index ?? 0] = exercise;
        }
      });
      response.data.exercises = sortedExercises.filter(Boolean);
    }

    return response;
  };

  getAll = async (
    options?: Omit<IHttpOptions, "body" | "method" | "url">,
  ): Promise<IResponse<ISession[], null[]>> => {
    const response = await this.getAllRequest(options);

    response.data.forEach((session) => {
      // manually sort the populated exercises based on the order of the exerciseIds in the session
      if (session.exercises) {
        const sortedExercises: IExercise[] = [];
        session.exercises.forEach((exercise) => {
          const index = session.exerciseIds?.indexOf(exercise._id);
          if (index !== undefined && index !== -1) {
            sortedExercises[index ?? 0] = exercise;
          }
        });
        // eslint-disable-next-line no-param-reassign -- We want to mutate the session object here to set the exercises in the correct order
        session.exercises = sortedExercises.filter(Boolean);
      }
    });

    return response;
  };
}

export const sessionService = new Service();
